import React from 'react';
import I18n from 'i18n-js';
import { Button, Space } from 'antd';
import {
  bool, func, number, oneOfType, shape, string,
} from 'prop-types';
import { isOrchard } from 'helpers/userSessionSettings';
import { CombineIcon, CropCycleIcon } from 'components/cwo-icons';
import { FilterListColor } from 'components/cwo-icon-pack';
import ToggleBtnSeasonAndFieldGroup from './ToggleBtnSeasonAndFieldGroup';
import ToggleButton from '../components/toggle-button';

const translate = (key) => I18n.t(`top_menu_right_part.${key}`);
const fieldGroupsLabel = translate(isOrchard ? 'orchard_plots' : 'field_groups');
const seasonLabel = translate('current_season');

const ToggleBtnGroup = ({
  fieldGroupsValue,
  isMachinery,
  isTimerRunning,
  loadMenuData,
  machineRegionsValue,
  productionCycleValue,
  showDrawer,
  showWorkRecord,
  timerString,
  seasonValue,
  options,
}) => {
  const {
    isShowCompanies, isShowProductionCycles, isShowMachineRegions,
  } = options || {};

  const dispatcherTimerContent = (showWorkRecord && isTimerRunning) ? (
    <div className="top-menu-field-groups__dispatcher-timer">
      <small>{timerString}</small>
    </div>
  ) : null;

  return (
    <>
      <Space
        className="top-menu-field-groups__toggle-btn-group"
        align="center"
        size={1}
      >
        <ToggleBtnSeasonAndFieldGroup
          fieldGroupLabel={isShowCompanies ? translate('companies') : fieldGroupsLabel}
          fieldGroupValue={fieldGroupsValue}
          loadMenuData={loadMenuData}
          seasonLabel={seasonLabel}
          seasonValue={seasonValue}
          showDrawer={showDrawer}
        />

        {
          isShowProductionCycles ? (
            <ToggleButton
              icon={<CropCycleIcon />}
              iconBackgroundColor="#FFF1F3"
              id="production-cycles-btn"
              label={translate('production_cycles')}
              loadMenuData={loadMenuData}
              showDrawer={showDrawer}
              toggleKey="2"
              value={productionCycleValue}
            />
          ) : null
        }

        {
          isShowMachineRegions ? (
            <ToggleButton
              dispatcherTimerContent={dispatcherTimerContent}
              icon={<CombineIcon color="#9A6412" width="20" height="20" />}
              iconBackgroundColor="#FFF3DD"
              id="machinery-regions-btn"
              isVisible={isMachinery}
              label={translate('machine_regions')}
              loadMenuData={loadMenuData}
              showDrawer={showDrawer}
              toggleKey="3"
              value={machineRegionsValue}
            />
          ) : null
        }
      </Space>

      <div className="top-menu-field-groups__dropdown-toggle-btn-group">
        <Button
          type="text"
          icon={<FilterListColor />}
          aria-label={fieldGroupsLabel}
          onClick={() => showDrawer('1')}
          onMouseOver={loadMenuData}
          onFocus={loadMenuData}
        />
      </div>
    </>
  );
};

ToggleBtnGroup.propTypes = {
  fieldGroupsValue: oneOfType([string, number]).isRequired,
  isMachinery: bool.isRequired,
  isTimerRunning: bool.isRequired,
  loadMenuData: func.isRequired,
  machineRegionsValue: string.isRequired,
  productionCycleValue: oneOfType([string, number]).isRequired,
  seasonValue: oneOfType([string, number]).isRequired,
  showDrawer: func.isRequired,
  showWorkRecord: bool.isRequired,
  timerString: string.isRequired,
  options: shape({
    isShowCompanies: bool,
    isShowProductionCycles: bool,
    isShowMachineRegions: bool,
  }).isRequired,
};

export default ToggleBtnGroup;
